import { Grid, Typography, Box, styled } from "@mui/material";

export const PopoverContainer = styled(Grid)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "5px",
  width: "100%",
});

export const AnomaliesListContainer = styled(Grid)<{ hasMoreAnomalies: boolean }>(({ hasMoreAnomalies }) => ({
  width: hasMoreAnomalies ? "calc(100% - 35px)" : "100%",
}));

export const AnomalyRow = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "baseline",
  width: "100%",
});

export const AnomalyTypeName = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: "11px",
  textWrap: "auto",
}));

export const AnomalyDaysCount = styled(Typography)({
  fontSize: "12px",
  minWidth: "50px",
  textAlign: "right",
});

export const PopoverContent = styled(Box)({
  padding: "8px",
  minWidth: "200px",
});

export const PopoverAnomalyRow = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "10px",
});
